var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 594.36 254.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}.cls-2{fill:none;stroke:#1c1c1c;stroke-miterlimit:10;stroke-width:15px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.65,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.99,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.33,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.67,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.01,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 240.35,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 281.69,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.03,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.37,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.71,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.05,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.38,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 529.72,
    y: 68.44,
    width: 27.71,
    height: 27.71
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.65,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.99,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.33,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.67,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.01,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 240.35,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 281.69,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.03,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.37,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.71,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.05,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.38,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 529.72,
    y: 109.93,
    width: 27.71,
    height: 27.71
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.65,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.99,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.33,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.67,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.01,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 240.35,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 281.69,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.03,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.37,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.71,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.05,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.38,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 529.72,
    y: 151.42,
    width: 27.71,
    height: 27.71
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.65,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.99,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.33,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.67,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.01,
    y: 192.91,
    width: 195.28,
    height: 27.71
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.71,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.05,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.38,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 529.72,
    y: 192.91,
    width: 27.71,
    height: 27.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1006.43,447.88V413.2H972.11v11.73h22.58v22.95H925.11V424.93h19.3V413.2h-31v34.68H662.72V667.69h594.36V447.88ZM1245.35,656H674.46V459.61h570.89Z",
    transform: "translate(-662.72 -413.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M959.9,419.06",
    transform: "translate(-662.72 -413.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.5d1f42ce2a668937c3517ee086606f3c.svg";
export { ForwardRef as ReactComponent };